import React from "react";
import classNames from "./classNames";

const Badge = ({ children, className, tone = "neutral", as: Element = "span" }) => (
  <Element className={classNames("badge", `badge--${tone}`, className)}>{children}</Element>
);

export default Badge;
